//-------------------------------------------------
// SITE CONTENT
//
// Previously stored in DatoCMS (project 117878, "Totally Funny Kids") and
// fetched at build time. Inlined so the site builds with no API token and no
// network access. Edit the copy here.
//
// The *Html fields hold the markdown DatoCMS had already rendered to HTML; they
// are injected with dangerouslySetInnerHTML exactly as before.
// ------------------------------------------------

export const index = {
  // Rendered into <h1>. Empty in the CMS, so the page ships an empty <h1>.
  title: '',

  launch: 'PREMIERING FEBRUARY 16th 2024 on',

  announcement: 'Coming soon to the CW.',

  uploadWarning: 'SELECTED VIDEOS WILL AIR ON THE SHOW!',

  uploadDescriptionHtml:
    '<p>If you have a video you think is appropriate for “<strong>Totally Funny Kids</strong>,” upload it here.</p>',

  bodyHtml:
    '<p>“<strong>TOTALLY FUNNY KIDS</strong>,” is a hilarious half-hour of funny video clips featuring the planet’s youngest citizens. Every episode features dozens of home videos and includes several viral videos with the Viral Video of The Week being selected at the end of every episode. Hosted by comedian Tacarra Williams "Totally Funny Kids” is destination television made for the whole family.</p>'
};

// /privacyeu renders these three fields. All were empty in the CMS, so the page
// shows only a background image and a Back link.
export const privacyeu = {
  title: '',
  subtitle: '',
  bodyHtml: ''
};
